import React from "react";
// @ts-ignore
import NavBar from "../../screens/SatCourse/CoursesScreen";
import { BsArrowLeft, BsChevronDoubleRight } from "react-icons/bs";
import { RiTimer2Fill } from "react-icons/ri";
import { GrFormPrevious } from "react-icons/gr";
// @ts-ignore
import ExpandArrow from "../../Assets/Images/Sat-images/export-arrow.webp";

export interface MockReadingData {
  readingparagraph: string;
}

export interface MockChoice {
  choiceno: string;
}

export interface MockQuizQuestion {
  questionNo: string;
  choices: MockChoice[];
}

export interface MockTestReadingProps {
  isLoading?: boolean;
  isError?: string | boolean;
  Error?: string;
  HandleId: () => void;
  title: string;
  readingData: MockReadingData[];
  quizQuestions: MockQuizQuestion[];
  goBack: () => void;
}

const MockTestReading: React.FC<MockTestReadingProps> = (props) => {
  let alphabet = 97;
  return (
    <>
      {props.isLoading ? (
        <h1>LOADING.........</h1>
      ) : (
        <div className="Home-Container">
          {props.isError ? (
            <h1>{props.Error}</h1>
          ) : (
            <div className="home-sub-container">
              <div>
                <NavBar />
              </div>
              <div className="main-right-container">
                <div className="mock-reading-first-section">
                  <div
                    onClick={() => {
                      props.goBack();
                    }}
                  >
                    <BsArrowLeft size="23px" />
                  </div>
                  <div className="timer-panel-mock-reading">
                    <RiTimer2Fill size="23px" />
                    <span>32:00</span>
                  </div>
                </div>
                <div className="mock-reading-second-section">
                  <div className="mock-reading-sub-section">
                    <div>{props.title}</div>
                    <div>
                      <img src={ExpandArrow} width="25px" height="25px" alt="Expand" />
                    </div>
                  </div>
                  <div className="mock-reading-sub-section">
                    <div className="mock-reading-quiz">Quiz</div>
                    <div className="mock-test-reading-question">
                      Question1/27
                    </div>
                  </div>
                </div>
                <div className="container-sat-reading-scroll">
                  <div className="reading-sat-left-side">
                    <p> {props.readingData && props.readingData[0]?.readingparagraph}</p>
                  </div>
                  <div className="line-div-reading"></div>
                  <div className="reading-sat-right-side">
                    <ol>
                      {props.quizQuestions?.length > 0 &&
                        props.quizQuestions.map((item, index) => {
                          return (
                            <React.Fragment key={index}>
                              <li>
                                <div className="question-div-reading">
                                  {item.questionNo}
                                </div>

                                <div className="choices-container-reading">
                                  {item.choices?.map((items, indexs) => {
                                    return (
                                      <React.Fragment key={indexs}>
                                        <div className="item-choices-reading-div">
                                          <p className="numbering-alpha">
                                            {String.fromCharCode(alphabet++)}
                                          </p>
                                          <p className="choices-reading-sat">
                                            {" "}
                                            {items.choiceno}
                                          </p>
                                        </div>
                                      </React.Fragment>
                                    );
                                  })}
                                </div>
                              </li>
                            </React.Fragment>
                          );
                        })}
                    </ol>
                  </div>
                </div>
                <div className="mock-reading-third-section">
                  <div className="mock-reading-sub-section-third">
                    <div>
                      <GrFormPrevious size="20px" />
                    </div>
                    <div className="icon-padding">Previous</div>
                  </div>
                  <div className="line-div-mock-t-read"></div>
                  <div className="mock-reading-sub-section-third">
                    <div className="icon-padding-next">Next</div>
                    <div>
                      {" "}
                      <BsChevronDoubleRight
                        size="14px"
                        fill="#A20107"
                        color="#A20107"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </>
  );
};
export default React.memo(MockTestReading);
